// AUTO-GENERATED SQL Builder (V40 Final) for LinkedAccountView
import { 
  SqlField, 
  SqlExp, 
  SqlExpChain, 
  SqlFn, 
  SqlLiteral, 
  SqlSubQuery, 
  SqlApplyColumn, 
  SqlNavHybrid, 
  createNavHybrid 
} from '../utils/sql-core';
import { SqlAst } from '../utils/sql-ast';

export class LinkedAccountViewSql {
  private ast = new SqlAst('LinkedAccountView', 'linkedAccountView');
  public readonly main: any = {};

  public id: SqlField;
  public vendorId: SqlField;
  public linkedAccountRef: SqlField;
  public status: SqlField;
  public setupStep: SqlField;
  public accountEmail: SqlField;
  public productRef: SqlField;
  public requirements: SqlField;
  public failureReason: SqlField;
  public bankName: SqlField;
  public accountNumberMasked: SqlField;
  public beneficiaryName: SqlField;
  public activatedDate: SqlField;
  public lastSyncedDate: SqlField;
  public createdDate: SqlField;
  public createdByName: SqlField;

  constructor() {
    this.id = new SqlField('linkedAccountView', 'id', '', 'id', 'linkedAccountView_id');
    this.vendorId = new SqlField('linkedAccountView', 'vendorId', 'vendor', 'id', 'linkedAccountView_vendor');
    this.linkedAccountRef = new SqlField('linkedAccountView', 'linkedAccountRef', '', 'id', 'linkedAccountView_linkedAccountRef');
    this.status = new SqlField('linkedAccountView', 'status', '', 'id', 'linkedAccountView_status');
    this.setupStep = new SqlField('linkedAccountView', 'setupStep', '', 'id', 'linkedAccountView_setupStep');
    this.accountEmail = new SqlField('linkedAccountView', 'accountEmail', '', 'id', 'linkedAccountView_accountEmail');
    this.productRef = new SqlField('linkedAccountView', 'productRef', '', 'id', 'linkedAccountView_productRef');
    this.requirements = new SqlField('linkedAccountView', 'requirements', '', 'id', 'linkedAccountView_requirements');
    this.failureReason = new SqlField('linkedAccountView', 'failureReason', '', 'id', 'linkedAccountView_failureReason');
    this.bankName = new SqlField('linkedAccountView', 'bankName', '', 'id', 'linkedAccountView_bankName');
    this.accountNumberMasked = new SqlField('linkedAccountView', 'accountNumberMasked', '', 'id', 'linkedAccountView_accountNumberMasked');
    this.beneficiaryName = new SqlField('linkedAccountView', 'beneficiaryName', '', 'id', 'linkedAccountView_beneficiaryName');
    this.activatedDate = new SqlField('linkedAccountView', 'activatedDate', '', 'id', 'linkedAccountView_activatedDate');
    this.lastSyncedDate = new SqlField('linkedAccountView', 'lastSyncedDate', '', 'id', 'linkedAccountView_lastSyncedDate');
    this.createdDate = new SqlField('linkedAccountView', 'createdDate', '', 'id', 'linkedAccountView_createdDate');
    this.createdByName = new SqlField('linkedAccountView', 'createdByName', '', 'id', 'linkedAccountView_createdByName');

    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v instanceof SqlField) this.main[k] = v;
    }
  }

  // SELECT
  select(fn:(x:LinkedAccountViewSql)=>any) {
    this.ast.addSelectObject(fn(this));
    return this;
  }

  // WHERE
  where(fn:(x:LinkedAccountViewSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  and(fn:(x:LinkedAccountViewSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  or(fn:(x:LinkedAccountViewSql)=>SqlExp | SqlExpChain) {
    this.ast.addOr(fn(this));
    return this;
  }

  // JOIN
  join(fn:(x:LinkedAccountViewSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f);
    return this;
  }
  leftJoin(fn:(x:LinkedAccountViewSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'LEFT');
    return this;
  }
  rightJoin(fn:(x:LinkedAccountViewSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'RIGHT');
    return this;
  }

  // AND JOIN
  andJoin(fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    const last = this.ast.joins[this.ast.joins.length - 1];
    if (!last) throw new Error('andJoin() before join()');

    const left = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(this.ast.alias, prop)
    });
    const right = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(last.alias, prop)
    });

    const exp = (this.ast as any).compileExp(fn(left, right));

    if (typeof last.on === 'string') {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[
          { column:last.on, operator:'', value:null, isTrusted:true, subFilters:[] },
          exp
        ]
      };
    }
    else if (last.on.logic === 'And') {
      last.on.subFilters.push(exp);
    }
    else {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[ last.on, exp ]
      };
    }

    return this;
  }

  // CTE
  with(name:string, fn:(c:any)=>any) {
    this.ast.with(name, fn);
    return this;
  }
  withRecursive(name:string, fn:(c:any)=>any) {
    this.ast.withRecursive(name, fn);
    return this;
  }

  // CTE JOIN
  joinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.joinCTE(name, alias, fn);
    return this;
  }
  fullJoinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.fullJoinCTE(name, alias, fn);
    return this;
  }

  // SUBQUERY
  subQuery(fn:(b:any)=>any) {
    return new SqlSubQuery(fn);
  }

  // APPLY
  apply(name:string, fn:(b:any)=>any) {
    this.ast.apply(name, fn);
    return this;
  }
  applyColumn(name:string, fn:(b:any)=>SqlField) {
    return this.ast.applyColumn(name, fn);
  }
  crossApply(app:any) {
    this.ast.crossApply(app);
    return this;
  }

  // GROUP BY
  groupBy(fn:(x:LinkedAccountViewSql)=>SqlField[]) {
    this.ast.addGroup(fn(this));
    return this;
  }

  // HAVING
  having(fn:(x:LinkedAccountViewSql)=>SqlExp | SqlExpChain) {
    this.ast.addHaving(fn(this));
    return this;
  }

  // ORDER
  orderBy(fn:(x:LinkedAccountViewSql)=>any[]) {
    this.ast.addOrder(fn(this));
    return this;
  }

  // UNION
  union(fn:(q:any)=>any) {
    this.ast.union(fn);
    return this;
  }
  unionAll(fn:(q:any)=>any) {
    this.ast.unionAll(fn);
    return this;
  }

  limit(n:number) { this.ast.take = n; return this; }
  offset(n:number) { this.ast.skip = n; return this; }

  build() {
    return this.ast.toQueryDescriptor();
  }
}
